<template>
	<div>
		<div id="info-panel">
			<div class="row align-items-center splash-box-row no-lr-margins">
				<div class="col align-self-center">
					<div class="container">
						<div class="row no-lr-margins">
							<div class="col">
								<div class="container info-controls">
									<div class="row no-lr-margins">
										<div class="col align-self-center">
											<div class="card">
												<div class="container info-logos-container">
													<div class="row info-logos-row">
														<div class="info-logos-col text-center">
															<img src="../assets/cd-head-image.jpg" class="info-logo" style="height:110px;">
															<h1 class="info-title">Feis Music Online</h1>
														</div>
													</div>
												</div>
												<div class="card-body info-controls-container">
													<form id="infoDialog" @submit="submit">
														<div>
															<div class="list-text">
																<p>
																	This website is completely free to use for the forseable future however if you do have a pound/euro/dollar spare, the Irish Cancer Society and St.Luke's Hospice would be delighted with any small donations. Please consider leaving a donation at:
																</p>
																<a href="https://www.justgiving.com/team/GerryConlonFeisMusic" target="_blank" rel="noopener noreferrer">Gerry Conlon's Just Giving Page</a> (Click 'Donate to a team member' and select one of the two charities.)
																<p></p>
															</div>
															<div class="donation-text">
																<a href="https://www.justgiving.com/team/GerryConlonFeisMusic" target="_blank" rel="noopener noreferrer">Gerry Conlon's Just Giving Page</a> (Click 'Donate to a team member' and select one of the two charities.)
																<p></p>
																<p>
																	Enjoy the music and Thank You all very much for your kind donations which will go directly to the charities.
																</p>
															</div>
															<div v-if="hasLogo === true">
																<div id="feis-logo-container">
																	<img :src="logoSrc" class="feis-logo">
																</div>
															</div>
															<!--<div v-if="hasLogo === false">
																<div class="info-controls-center info-header">
																	<h5 class="info-text all-text">Recent Updates</h5>
																</div>
																<div class="updates">
																	<p class="update-bullet">26-May-2021 Added new Online Feis profile:</p>
																	<ul>
																		<li><b>Fo-Chomórtaisí Oir na Mumhan 2021 (Mini Munsters)</b></li>
																	</ul>
																	<p class="update-bullet">24-May-2021 Added An Chomhdháil Set Dances:</p>
																	<p>(At a wide variety of speeds and ability to drill set/step on repeat and in isolation)</p>
																	<ul>
																		<li><b>Little Heathy Hill (Hornpipe set)</b></li>
																		<li><b>Mary Ellen Bradley (Hornpipe set)</b></li>
																		<li><b>O'Doherty's Keep (Hornpipe set)</b></li>
																		<li><b>Planxty Keogh (Hornpipe set)</b></li>
																		<li><b>The Deep Green Pool (Jig set)</b></li>
																		<li><b>Donegal Rambler (Jig set)</b></li>
																		<li><b>Planxty Irwin (Jig set)</b></li>
																		<li><b>Ri Laois (Jig set)</b></li>
																		<li><b>Road To Dunblane (Jig set)</b></li>
																		<li><b>Three Sea Captains (Long Version) (Jig set)</b></li>
																	</ul>
																	<p class="update-bullet">21-May-2021 Added long tracks for dance classes (Password controlled at present):</p>
																	<ul>
																		<li><b>Beginners:</b> (8)Reels, (5)Slip Jigs, (5)Heavy Jigs and (2)Hornpipes</li>
																		<li><b>Primary:</b> (4)Reels, (5)Slip Jigs, (11)Heavy Jigs and (10)Hornpipes</li>
																		<li><b>Intermediate:</b> (12)Reels, (10)Slip Jigs, (8)Heavy Jigs and (9)Hornpipes</li>
																		<li><b>Open:</b> (12)Reels, (10)Slip Jigs, (8)Heavy Jigs and (9)Hornpipes</li>
																	</ul>
																	<p class="update-bullet">10-May-2021 Added 22 New tracks:</p>
																	<ul>
																		<li><b>Light Jigs</b>: The Campbells Are Coming, King's Favourite,	Rosemary Lane (McCann's Jig), The Rakes Of Kildare,	The Kesh Jig, Trad In D, Willie Coleman's </li>
																		<li><b>Beg. Reels</b>: Asailin Ag Seainin,	Church Street, The Glenside No.2, Humours Of Ballydesmond, Jenny Lind, Jim McKeefe's Polka,	John Cliffords,	La Russe, Terry Teehan's, The Grand Old Dame, The Gurteen Cross, The Lakes Of Sligo, The Rose Tree, Tripping To The Well, Where Lilies Bloom</li>
																	</ul>
																	<p class="update-bullet">03-May-2021 Added Profiles for the following online feis/regions:</p>
																	<ul>
																		<li>The Brady Academy Feis</li>
																		<li>Connacht region</li>
																		<li>IDTACe</li>
																		<li>RCCEA</li>
																	</ul>
																</div>
															</div> -->
														</div>
														<div class="info-controls-center">
															<div id="region-selector">
																<select class="speed-selector" ref="regionInputRef" @change="onChange($event)" aria-label="Select regional speeds">
																	<option value="" selected>Select your feis...</option>
																	<option v-for="item in options.default" :key="item?.region" :value="item?.region" class="dropdown-item">{{item?.region}}</option>
																</select>
															</div>
														
															<div id="action-buttons">
																<div v-if="hasSyllabus">
																	<a class="btn btn-syllabus action-button-smaller" :href="syllabusName" target="_blank" rel="noopener noreferrer">Syllabus</a>
																	
																	<button type="submit" class="btn site-btn-primary action-button-smaller" :disabled="isDisabled">
																		Continue
																	</button>
																	<!-- Need a way back (TEMP) -->
																	<router-link :to="{ name: 'home'}">
																		<button type="submit" class="btn site-btn-outline-primary action-button-smaller">
																			Back
																		</button>
																	</router-link>
																</div>
																<div v-else>
																	<button type="submit" class="btn site-btn-primary action-button" :disabled="isDisabled">
																		Continue
																	</button>
																	<!-- Need a way back (TEMP) -->
																	<router-link :to="{ name: 'home'}">
																		<button type="submit" class="btn site-btn-outline-primary action-button">
																			Back
																		</button>
																	</router-link>
																</div>
															</div>
														</div>
													</form>
													<div class="row">
														<div class="support-msg all-text">
															<p><b>Disclaimer:</b> This is not an App and therefore requires either WiFi or a mobile signal to function efficiently. All music is <b>streamed</b> and will not be downloaded to your device.</p>
														</div>
													</div>
													<div class="row">
														<div class="support-msg support-text">
															<p><b>Enquiries:</b> support@feis.gerryconlon.com</p>
														</div>
													</div>
													<div class="row">
														<div class="copyright-msg support-text">
															<p>@Copyright 2021</p>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent, ref, inject, onMounted, onBeforeMount } from "vue";
// eslint-disable-next-line no-unused-vars
import IAuthenticationService from "../interfaces/authentication_service";
// eslint-disable-next-line no-unused-vars
import IConfigurationService from "../interfaces/configuration_service";
// eslint-disable-next-line no-unused-vars
import IRegions, { IRegionFilters } from "@/interfaces/region_filters";

import router from "../router";

interface IRegionSelectorOption
{
	region: string
}

export default defineComponent({
	setup()
	{
		const regionInputRef = ref<HTMLElementTagNameMap>();
		const authenticationService = inject<IAuthenticationService>("authenticationService");
		const configurationService = inject<IConfigurationService>("configurationService");
		
		const options = ref<IRegions>();
		const selectedOption = ref<IRegionSelectorOption>();
		const isDisabled = ref<boolean>();
		const isFeis = ref<boolean>(false);
		const isClass = ref<boolean>(false);
		const hasLogo = ref<boolean>(false);
		const logoSrc = ref<string>("");
		const hasSyllabus = ref<boolean>(false);
		const syllabusName = ref<string>("/syllabus/Brady Academy Feis.pdf");

		if (!configurationService)
		{
			throw new Error("Configuration service not initialised");
		}

		async function submit(evt:Event)
		{
			console.log(`SUBMIT button pressed...`)
			if (!authenticationService)
			{
				console.log(`Authentication service not initialised...`)
			
				throw new Error("Authentication service not initialised");
			}

			if (evt)
			{
				evt.preventDefault();
			}
			authenticationService.setTempAuthentication();
						
			router.replace({ name: "music" });
		}

		function loadRegionFilters()
		{
			let regionFilters = configurationService?.getOnlineFeisList();
			if (regionFilters)
			{
				options.value = regionFilters;
			}
		}

		function onChange(event: any)
		{
			isFeis.value = false;
			isClass.value = false;
			hasLogo.value = false;
			logoSrc.value = "";
			hasSyllabus.value = false;
			syllabusName.value = "";

			if (event.target.value)
			{
				// Just set the selected region so that we can use it later
				isDisabled.value = false;
				configurationService?.setSelectedRegion(event.target.value);

				const region = configurationService?.getSelectedRegion();
				if (region)
				{
					const isAFeis = region?.map((item: IRegionFilters) => item?.isFeis);
					const isAClass = region?.map((item: IRegionFilters) => item?.isClass);
					const hasALogo = region?.map((item: IRegionFilters) => item?.hasLogo);
					const hasASyllabus = region?.map((item: IRegionFilters) => item?.hasSyllabus);

					isFeis.value = (isAFeis && isAFeis[0] === "true");	
					isClass.value = (isAClass && isAClass[0] === "true");
					hasLogo.value = (hasALogo && hasALogo[0] === "true");
					if (hasLogo.value)
					{
						logoSrc.value = region?.map((item: IRegionFilters) => item?.logoSrc)
					}
					hasSyllabus.value = (hasASyllabus && hasASyllabus[0] === "true");	
					if (hasSyllabus.value)
					{
						syllabusName.value = region?.map((item: IRegionFilters) => item?.syllabusName);
					}
				}
			}
			else
			{
				isDisabled.value = true;
			}
		}

		onBeforeMount(function()
		{
			isDisabled.value = true;
			loadRegionFilters();
		});
		
		onMounted(function()
		{
			setTimeout(() => 
			{
				if (regionInputRef.value)
				{
					// regionInputRef.value.focus();
				}
				
			}, 300);
		});

		return {
			regionInputRef,
			submit,
			options,
			selectedOption,
			onChange,
			isDisabled,
			isFeis,
			isClass,
			hasLogo,
			logoSrc,
			hasSyllabus,
			syllabusName
		};
	}
});
</script>

<style lang="scss" scoped>
@import "../styles/palette";
@import "../styles/layout";

.support-msg
{
	width: 100%;
	font-size: 10px;
	text-align: center;
	padding-left: 0;
	margin-left: 0;
	padding-top: 35px;
	padding-bottom: 0px;
}
.copyright-msg
{
	width: 100%;
	font-size: 10px;
	text-align: center;
	font-weight: bold;
	padding-right: 0;
	margin-right: 0;
	padding-top: 0px;
}

#region-selector
{
	display: flex;
	justify-content: left;
	align-items: flex-start;
	background-color: $actions-page-2;
}

#action-buttons
{
	display: flex;
	justify-content: center;
	flex-direction: row;	
	justify-content: space-evenly;
}
.action-button
{
	max-width: pxToRem(175px);
}
.action-button-smaller
{
	max-width: pxToRem(100px);
}

@media only screen and (max-width: 780px) {
	#action-buttons
	{
		flex-wrap: wrap;
	}
}
.speed-selector
{
	display: block;
	width: 100%;
	height: calc(1.5em + 0.75rem + 2px);
	font-size: 1rem;
	font-weight: 400;
	line-height: 1.5;
	align-items: center;
	border-color: $primary-purple-2;
	border-radius: 0.25rem;
	border: 1px solid #ced4da; 
	background-color: #fff;
	color: #495057;
	padding: .375rem .50rem;
	transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;

}
.speed-selector:focus
{
	color: #495057;
	background-color: #fff;
	border-color: #6e96d5;
	outline: 0;
	box-shadow: 0 0 0 0.2rem rgb(44 86 151 / 25%);
}

.info-header
{
	p {
		font-size: 12px;
	}
}
#feis-logo-container
{
	padding-top: 20px;
	padding-bottom:20px;
	display: flex;
    justify-content: center;
}
.feis-logos-row
{
	margin-top: 20px;
	margin-bottom: 20px;
}

.info-controls
{
	max-width: 500px !important;
	// text-align: center;
}

.info-controls-center
{
	text-align: center;
}

.info-logo
{
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.info-logos-container
{
	padding: 0px;
}

.info-logos-row
{
	margin: 0px;
}
.info-logos-col
{
	margin-left: 0px;
	padding-left: 0px;
	padding-bottom: 0px;
}

.info-logo, .info-logos-col 
{
	width: 100%;
}

.info-controls-container
{
	background-color: $actions-page-2;
}

.info-text
{
	margin-bottom: 0px;
	padding-bottom: 0px;
}

.info-input
{
	margin-bottom: 10px;
}

.info-title
{
	color: $primary-purple-2;
	font-size: 30px;
	font-family: Apple Chancery, cursive;
	font-weight: bold;
	font-style: italic;
	position: relative;
	top: -50px;
	height: 0;
	text-align: center;
}
.all-text, .support-text {
	font-family: Apple Chancery, cursive;
	font-style: italic;
	text-align: left;
	color: $primary-purple-2;
}
.support-text 
{
	text-align: center;
}
.list-text, .donation-text {
	font-family: Apple Chancery, cursive;
	font-style: italic;
	//text-align: left;
	font-weight: normal;
	font-size: 12px;
	color: $primary-purple-2;
}
.donation-text {
	display: none;
}

ol { counter-reset: item; list-style-type: none; }
ol > li:before { content: counters(item, ".") ". "; counter-increment: item }
ul { list-style-type: disc; padding-left: 40px;}
.info-button
{
	margin-top: 25px;
	margin-bottom: 10px;
}


:not(output):-moz-ui-invalid:not(:focus) {
  box-shadow: none;
}

:not(output):-moz-ui-invalid:-moz-focusring:not(:focus) {
  box-shadow: none;
}
#info-panel
{
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100vh;
}
div.updates
{
	height: 200px;
	max-height: 200px;
	margin-top: 15px;
	margin-bottom: 25px;  
	background-color: white;
	overflow: auto;
}
.update-bullet 
{
	font-weight: bold;
	margin-left: 10px;
	font-size: 10pt;
	color: red;
}
.site-btn-primary {
	border-radius: pxToRem(25px);
	border: solid pxToRem(2px);
	margin-top: pxToRem(20px);
	margin-left: pxToRem(10px);
	margin-right: pxToRem(10px);
	width: pxToRem(200px);
	color: white;
	background-color: $primary-purple-2;
}
.site-btn-primary:hover, 
.site-btn-primary:focus, 
.site-btn-primary:active, 
.site-btn-primary.active, .open>.dropdown-toggle.site-btn-primary {
    color: #fff;
    background-color: $primary-purple-2;
    border-color: $secondary-purple-2;
}
.site-btn-outline-primary:hover, 
.site-btn-outline-primary:focus, 
.site-btn-outline-primary:active, 
.site-btn-outline-primary.active, .open>.dropdown-toggle.site-btn-outline-primary {
    color: #fff;
    background-color: $primary-feis-red-1;
    border-color: $secondary-purple-2;
}
.btn-syllabus {
	border-radius: 25px;
	border: solid pxToRem(2px);
	margin-top: pxToRem(20px);
	margin-left: pxToRem(10px);
	margin-right: pxToRem(10px);
	width: pxToRem(200px);
	color: white;
	background-color:$primary-blue-2;
    border-color: $secondary-purple-2;
}

@media only screen and (max-width: 1920px) {
	.info-title
	{
		font-size: 26px;
	}
	.support-msg
	{
		font-size: 12px;
	}
	.copyright-msg
	{
		font-size: 8px;
	}
}

@media only screen and (max-width: 450px) {
	.card
	{
		margin-left: pxToRem(15px);
		margin-right: pxToRem(15px);
	}
}

@media only screen and (max-width: 414px) {
	.info-title
	{
		font-size: 26px;
	}
	.support-msg
	{
		font-size: 10px;
	}
	.copyright-msg
	{
		font-size: 8px;
	}
	.donation-text
	{
		display: block;
	}
	.list-text
	{
		display: none;
	}
}

@media only screen and (max-width: 375px) {
	.info-title
	{
		font-size: 24px;
	}
	.info-input
	{
		font-size: 12px;
	}
	.speed-selector
	{
		font-size: 12px;
	}
}

@media only screen and (max-width: 320px) {
	.info-title
	{
		font-size: 18px;
	}
	.info-input
	{
		font-size: 12px;
	}
	.speed-selector
	{
		font-size: 12px;
	}
}
@media only screen and (max-width: 280px) {
	.info-title
	{
		font-size: 18px;
	}
	.info-input
	{
		font-size: 12px;
	}
	.speed-selector
	{
		font-size: 12px;
	}
}
</style>
